module.exports = __webpack_public_path__ + "static/media/cilogo.9a953dc7.jpg";